import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import ConfigPage from './components/ConfigPage';
import CallPage from './components/CallPage';
import './App.css';

function App() {
  return (
    <div className="App">
      <nav className="navbar">
        <div className="container">
          <div className="nav-content">
            <h1 className="nav-title">🎙️ AI Voice Bot</h1>
            <div className="nav-links">
              <Link to="/" className="nav-link">Configuration</Link>
              <Link to="/call" className="nav-link">Voice Call</Link>
            </div>
          </div>
        </div>
      </nav>

      <main className="main-content">
        <Routes>
          <Route path="/" element={<ConfigPage />} />
          <Route path="/call" element={<CallPage />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
